
// outsource dependencies
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
// STYLES inject ...
import './style';
// polyfill
import './polyfill';
// local dependencies
import { App } from './app';
import { store } from './constant';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
